import Vue from 'vue'
import App from './App.vue'
import router, { ensurePermissionRoutes, getPermissionHomePath } from './router'
import store from './store'
import Antd from 'ant-design-vue'
import { defaultAdminPath } from './config/adminNavigation'
import './styles/admin-theme.css'

// 使用 CSS 版本，避免 less-loader 版本兼容问题
import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false
Vue.use(Antd)

// 路由守卫：未登录重定向到登录页
router.beforeEach((to, from, next) => {
  const loggedIn = store.getters['user/isLoggedIn']
  const permissionMenus = store.state.permissionMenus || []

  if (loggedIn && permissionMenus.length) {
    ensurePermissionRoutes(permissionMenus)

    if (to.path === '/login') {
      next(getPermissionHomePath(permissionMenus))
      return
    }
  }

  if (to.meta.requiresAuth !== false && !loggedIn) {
    next('/login')
    return
  }

  if (to.path === '/login' && loggedIn) {
    next(permissionMenus.length ? getPermissionHomePath(permissionMenus) : defaultAdminPath)
    return
  }

  next()
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
